"use strict";

var _createForOfIteratorHelper = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _slicedToArray = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _regeneratorRuntime = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var tx_1 = require("@ethereumjs/tx");

var ethereumjs_util_1 = require("ethereumjs-util");

var ContractInteractor_1 = require("@opengsn/common/dist/ContractInteractor");

var VersionsManager_1 = require("@opengsn/common/dist/VersionsManager");

var Utils_1 = require("@opengsn/common/dist/Utils");

var Version_1 = require("@opengsn/common/dist/Version");

var AccountManager_1 = require("./AccountManager");

var HttpClient_1 = require("@opengsn/common/dist/HttpClient");

var HttpWrapper_1 = require("@opengsn/common/dist/HttpWrapper");

var RelaySelectionManager_1 = require("./RelaySelectionManager");

var RelayedTransactionValidator_1 = require("./RelayedTransactionValidator");

var KnownRelaysManager_1 = require("./KnownRelaysManager");

var ClientWinstonLogger_1 = require("./ClientWinstonLogger");

var GSNConfigurator_1 = require("./GSNConfigurator");

var GsnEvents_1 = require("./GsnEvents"); // forwarder requests are signed with expiration time.


var REQUEST_VALID_BLOCKS = 6000; // roughly a day
// generate "approvalData" and "paymasterData" for a request.
// both are bytes arrays. paymasterData is part of the client request.
// approvalData is created after request is filled and signed.

exports.EmptyDataCallback = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", '0x');

        case 1:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));

exports.GasPricePingFilter = function (pingResponse, gsnTransactionDetails) {
  if (gsnTransactionDetails.gasPrice != null && parseInt(pingResponse.minGasPrice) > parseInt(gsnTransactionDetails.gasPrice)) {
    throw new Error("Proposed gas price: ".concat(gsnTransactionDetails.gasPrice, "; relay's MinGasPrice: ").concat(pingResponse.minGasPrice));
  }
};

var RelayClient = /*#__PURE__*/function () {
  function RelayClient(rawConstructorInput) {
    _classCallCheck(this, RelayClient);

    var _a, _b, _c, _d;

    this.emitter = new events_1.EventEmitter();
    this.initialized = false; // TODO: backwards-compatibility 102 - remove on next version bump

    if (arguments[0] == null || arguments[0].send != null || arguments[2] != null) {
      throw new Error('Sorry, but the constructor parameters of the RelayClient class have changed. See "GSNUnresolvedConstructorInput" interface for details.');
    }

    this.rawConstructorInput = rawConstructorInput;
    this.logger = (_b = (_a = rawConstructorInput.overrideDependencies) === null || _a === void 0 ? void 0 : _a.logger) !== null && _b !== void 0 ? _b : ClientWinstonLogger_1.createClientLogger((_d = (_c = rawConstructorInput.config) === null || _c === void 0 ? void 0 : _c.loggerConfiguration) !== null && _d !== void 0 ? _d : GSNConfigurator_1.defaultLoggerConfiguration);
  }

  _createClass(RelayClient, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.initialized) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('init() already called');

              case 2:
                this.initializingPromise = this._initInternal();
                _context2.next = 5;
                return this.initializingPromise;

              case 5:
                this.initialized = true;
                return _context2.abrupt("return", this);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "_initInternal",
    value: function () {
      var _initInternal2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.emit(new GsnEvents_1.GsnInitEvent());
                _context3.next = 3;
                return this._resolveConfiguration(this.rawConstructorInput);

              case 3:
                this.config = _context3.sent;
                _context3.next = 6;
                return this._resolveDependencies(this.rawConstructorInput);

              case 6:
                this.dependencies = _context3.sent;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _initInternal() {
        return _initInternal2.apply(this, arguments);
      }

      return _initInternal;
    }()
    /**
     * register a listener for GSN events
     * @see GsnEvent and its subclasses for emitted events
     * @param handler callback function to handle events
     */

  }, {
    key: "registerEventListener",
    value: function registerEventListener(handler) {
      this.emitter.on('gsn', handler);
    }
    /**
     * unregister previously registered event listener
     * @param handler callback function to unregister
     */

  }, {
    key: "unregisterEventListener",
    value: function unregisterEventListener(handler) {
      this.emitter.off('gsn', handler);
    }
  }, {
    key: "emit",
    value: function emit(event) {
      this.emitter.emit('gsn', event);
    }
    /**
     * In case Relay Server does not broadcast the signed transaction to the network,
     * client also broadcasts the same transaction. If the transaction fails with nonce
     * error, it indicates Relay may have signed multiple transactions with same nonce,
     * causing a DoS attack.
     *
     * @param {*} transaction - actual Ethereum transaction, signed by a relay
     */

  }, {
    key: "_broadcastRawTx",
    value: function () {
      var _broadcastRawTx2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(transaction) {
        var rawTx, txHash;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                rawTx = '0x' + transaction.serialize().toString('hex');
                txHash = '0x' + transaction.hash().toString('hex');
                this.logger.info("Broadcasting raw transaction signed by relay. TxHash: ".concat(txHash));
                _context4.prev = 3;
                _context4.next = 6;
                return this._isAlreadySubmitted(txHash);

              case 6:
                if (!_context4.sent) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return", {
                  hasReceipt: true
                });

              case 8:
                _context4.next = 10;
                return this.dependencies.contractInteractor.sendSignedTransaction(rawTx);

              case 10:
                return _context4.abrupt("return", {
                  hasReceipt: true
                });

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](3);

                if (!((_context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.message.match(/the tx doesn't have the correct nonce|known transaction/)) != null)) {
                  _context4.next = 17;
                  break;
                }

                return _context4.abrupt("return", {
                  hasReceipt: false,
                  wrongNonce: true,
                  broadcastError: _context4.t0
                });

              case 17:
                return _context4.abrupt("return", {
                  hasReceipt: false,
                  broadcastError: _context4.t0
                });

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 13]]);
      }));

      function _broadcastRawTx(_x) {
        return _broadcastRawTx2.apply(this, arguments);
      }

      return _broadcastRawTx;
    }()
  }, {
    key: "_isAlreadySubmitted",
    value: function () {
      var _isAlreadySubmitted2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(txHash) {
        var _yield$Promise$all, _yield$Promise$all2, txMinedReceipt, pendingBlock;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Promise.all([this.dependencies.contractInteractor.web3.eth.getTransactionReceipt(txHash), // mempool transactions
                this.dependencies.contractInteractor.web3.eth.getBlock('pending')]);

              case 2:
                _yield$Promise$all = _context5.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                txMinedReceipt = _yield$Promise$all2[0];
                pendingBlock = _yield$Promise$all2[1];

                if (!(txMinedReceipt != null)) {
                  _context5.next = 8;
                  break;
                }

                return _context5.abrupt("return", true);

              case 8:
                return _context5.abrupt("return", pendingBlock.transactions.includes(txHash));

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _isAlreadySubmitted(_x2) {
        return _isAlreadySubmitted2.apply(this, arguments);
      }

      return _isAlreadySubmitted;
    }()
  }, {
    key: "relayTransaction",
    value: function () {
      var _relayTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(gsnTransactionDetails) {
        var _a, _b, _c, estimated, relaySelectionManager, count, relayingErrors, auditPromises, paymaster, relayingAttempt, activeRelay;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.initialized) {
                  _context6.next = 4;
                  break;
                }

                if (this.initializingPromise == null) {
                  this._warn('suggestion: call RelayProvider.init()/RelayClient.init() in advance (to make first request faster)');
                }

                _context6.next = 4;
                return this.init();

              case 4:
                // TODO: should have a better strategy to decide how often to refresh known relays
                this.emit(new GsnEvents_1.GsnRefreshRelaysEvent());
                _context6.next = 7;
                return this.dependencies.knownRelaysManager.refresh();

              case 7:
                if (!((_a = gsnTransactionDetails.forceGasPrice) !== null && _a !== void 0)) {
                  _context6.next = 11;
                  break;
                }

                _context6.t0 = _a;
                _context6.next = 14;
                break;

              case 11:
                _context6.next = 13;
                return this._calculateGasPrice();

              case 13:
                _context6.t0 = _context6.sent;

              case 14:
                gsnTransactionDetails.gasPrice = _context6.t0;

                if (!(gsnTransactionDetails.gas == null)) {
                  _context6.next = 20;
                  break;
                }

                _context6.next = 18;
                return this.dependencies.contractInteractor.estimateGas(gsnTransactionDetails);

              case 18:
                estimated = _context6.sent;
                gsnTransactionDetails.gas = "0x".concat(estimated.toString(16));

              case 20:
                _context6.next = 22;
                return new RelaySelectionManager_1.RelaySelectionManager(gsnTransactionDetails, this.dependencies.knownRelaysManager, this.dependencies.httpClient, this.dependencies.pingFilter, this.logger, this.config).init();

              case 22:
                relaySelectionManager = _context6.sent;
                count = relaySelectionManager.relaysLeft().length;
                this.emit(new GsnEvents_1.GsnDoneRefreshRelaysEvent(count));

                if (!(count === 0)) {
                  _context6.next = 27;
                  break;
                }

                throw new Error('no registered relayers');

              case 27:
                relayingErrors = new Map();
                auditPromises = [];
                paymaster = this.dependencies.contractInteractor.getDeployment().paymasterAddress;

              case 30:
                if (!true) {
                  _context6.next = 48;
                  break;
                }

                relayingAttempt = void 0;
                _context6.next = 34;
                return relaySelectionManager.selectNextRelay(paymaster);

              case 34:
                activeRelay = _context6.sent;

                if (!(activeRelay != null)) {
                  _context6.next = 45;
                  break;
                }

                this.emit(new GsnEvents_1.GsnNextRelayEvent(activeRelay.relayInfo.relayUrl));
                _context6.next = 39;
                return this._attemptRelay(activeRelay, gsnTransactionDetails).catch(function (error) {
                  return {
                    error: error
                  };
                });

              case 39:
                relayingAttempt = _context6.sent;

                if (relayingAttempt.auditPromise != null) {
                  auditPromises.push(relayingAttempt.auditPromise);
                }

                if (!(relayingAttempt.transaction == null)) {
                  _context6.next = 45;
                  break;
                }

                relayingErrors.set(activeRelay.relayInfo.relayUrl, (_b = relayingAttempt.error) !== null && _b !== void 0 ? _b : new Error('No error reason was given'));

                if (!((_c = relayingAttempt.isRelayError) !== null && _c !== void 0 ? _c : false)) {
                  _context6.next = 45;
                  break;
                }

                return _context6.abrupt("continue", 30);

              case 45:
                return _context6.abrupt("return", {
                  transaction: relayingAttempt === null || relayingAttempt === void 0 ? void 0 : relayingAttempt.transaction,
                  relayingErrors: relayingErrors,
                  auditPromises: auditPromises,
                  pingErrors: relaySelectionManager.errors
                });

              case 48:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function relayTransaction(_x3) {
        return _relayTransaction.apply(this, arguments);
      }

      return relayTransaction;
    }()
  }, {
    key: "_warn",
    value: function _warn(msg) {
      this.logger.warn(msg);
    }
  }, {
    key: "_calculateGasPrice",
    value: function () {
      var _calculateGasPrice2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var pct, networkGasPrice, gasPrice;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                pct = this.config.gasPriceFactorPercent;
                _context7.next = 3;
                return this.dependencies.contractInteractor.getGasPrice();

              case 3:
                networkGasPrice = _context7.sent;
                gasPrice = Math.round(parseInt(networkGasPrice) * (pct + 100) / 100);

                if (this.config.minGasPrice != null && gasPrice < this.config.minGasPrice) {
                  gasPrice = this.config.minGasPrice;
                }

                return _context7.abrupt("return", "0x".concat(gasPrice.toString(16)));

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _calculateGasPrice() {
        return _calculateGasPrice2.apply(this, arguments);
      }

      return _calculateGasPrice;
    }()
  }, {
    key: "_attemptRelay",
    value: function () {
      var _attemptRelay2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(relayInfo, gsnTransactionDetails) {
        var _this = this;

        var maxAcceptanceBudget, httpRequest, acceptRelayCallResult, message, hexTransaction, transaction, auditPromise, validationError;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.logger.info("attempting relay: ".concat(JSON.stringify(relayInfo), " transaction: ").concat(JSON.stringify(gsnTransactionDetails)));
                maxAcceptanceBudget = parseInt(relayInfo.pingResponse.maxAcceptanceBudget);
                _context8.next = 4;
                return this._prepareRelayHttpRequest(relayInfo, gsnTransactionDetails);

              case 4:
                httpRequest = _context8.sent;
                this.emit(new GsnEvents_1.GsnValidateRequestEvent());
                _context8.next = 8;
                return this.dependencies.contractInteractor.validateRelayCall(maxAcceptanceBudget, httpRequest.relayRequest, httpRequest.metadata.signature, httpRequest.metadata.approvalData, this.config.maxViewableGasLimit);

              case 8:
                acceptRelayCallResult = _context8.sent;

                if (acceptRelayCallResult.paymasterAccepted) {
                  _context8.next = 12;
                  break;
                }

                if (acceptRelayCallResult.reverted) {
                  message = 'local view call to \'relayCall()\' reverted';
                } else {
                  message = 'paymaster rejected in local view call to \'relayCall()\' ';
                }

                return _context8.abrupt("return", {
                  error: new Error("".concat(message, ": ").concat(Utils_1.decodeRevertReason(acceptRelayCallResult.returnValue)))
                });

              case 12:
                this.emit(new GsnEvents_1.GsnSendToRelayerEvent(relayInfo.relayInfo.relayUrl));
                _context8.prev = 13;
                _context8.next = 16;
                return this.dependencies.httpClient.relayTransaction(relayInfo.relayInfo.relayUrl, httpRequest);

              case 16:
                hexTransaction = _context8.sent;
                transaction = tx_1.Transaction.fromSerializedTx(ethereumjs_util_1.toBuffer(hexTransaction), this.dependencies.contractInteractor.getRawTxOptions());
                auditPromise = this.auditTransaction(hexTransaction, relayInfo.relayInfo.relayUrl).then(function (penalizeResponse) {
                  if (penalizeResponse.commitTxHash != null) {
                    var txHash = ethereumjs_util_1.bufferToHex(transaction.hash());

                    _this.logger.error("The transaction with id: ".concat(txHash, " was penalized! Penalization commitment tx id: ").concat(penalizeResponse.commitTxHash));
                  }

                  return penalizeResponse;
                });
                _context8.next = 26;
                break;

              case 21:
                _context8.prev = 21;
                _context8.t0 = _context8["catch"](13);

                if ((_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message) == null || _context8.t0.message.indexOf('timeout') !== -1) {
                  this.dependencies.knownRelaysManager.saveRelayFailure(new Date().getTime(), relayInfo.relayInfo.relayManager, relayInfo.relayInfo.relayUrl);
                }

                this.logger.info("relayTransaction: ".concat(JSON.stringify(httpRequest)));
                return _context8.abrupt("return", {
                  error: _context8.t0,
                  isRelayError: true
                });

              case 26:
                try {
                  if (!this.dependencies.transactionValidator.validateRelayResponse(httpRequest, maxAcceptanceBudget, hexTransaction)) {
                    validationError = new Error('Returned transaction did not pass validation');
                  }
                } catch (e) {
                  validationError = e;
                }

                if (!(validationError != null)) {
                  _context8.next = 31;
                  break;
                }

                this.emit(new GsnEvents_1.GsnRelayerResponseEvent(false));
                this.dependencies.knownRelaysManager.saveRelayFailure(new Date().getTime(), relayInfo.relayInfo.relayManager, relayInfo.relayInfo.relayUrl);
                return _context8.abrupt("return", {
                  auditPromise: auditPromise,
                  isRelayError: true,
                  error: validationError
                });

              case 31:
                this.emit(new GsnEvents_1.GsnRelayerResponseEvent(true));
                _context8.next = 34;
                return this._broadcastRawTx(transaction);

              case 34:
                return _context8.abrupt("return", {
                  auditPromise: auditPromise,
                  transaction: transaction
                });

              case 35:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[13, 21]]);
      }));

      function _attemptRelay(_x4, _x5) {
        return _attemptRelay2.apply(this, arguments);
      }

      return _attemptRelay;
    }()
  }, {
    key: "_prepareRelayHttpRequest",
    value: function () {
      var _prepareRelayHttpRequest2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(relayInfo, gsnTransactionDetails) {
        var _a, relayHubAddress, forwarder, paymaster, validUntilPromise, senderNonce, relayWorker, gasPriceHex, gasLimitHex, gasLimit, gasPrice, value, relayRequest, signature, approvalData, transactionCount, relayMaxNonce, metadata, httpRequest;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                relayHubAddress = this.dependencies.contractInteractor.getDeployment().relayHubAddress;
                forwarder = this.dependencies.contractInteractor.getDeployment().forwarderAddress;
                paymaster = this.dependencies.contractInteractor.getDeployment().paymasterAddress;

                if (!(relayHubAddress == null || paymaster == null || forwarder == null)) {
                  _context9.next = 5;
                  break;
                }

                throw new Error('Contract addresses are not initialized!');

              case 5:
                // valid that many blocks into the future.
                validUntilPromise = this.dependencies.contractInteractor.getBlockNumber().then(function (num) {
                  return (num + REQUEST_VALID_BLOCKS).toString();
                });
                _context9.next = 8;
                return this.dependencies.contractInteractor.getSenderNonce(gsnTransactionDetails.from, forwarder);

              case 8:
                senderNonce = _context9.sent;
                relayWorker = relayInfo.pingResponse.relayWorkerAddress;
                gasPriceHex = gsnTransactionDetails.gasPrice;
                gasLimitHex = gsnTransactionDetails.gas;

                if (!(gasPriceHex == null || gasLimitHex == null)) {
                  _context9.next = 14;
                  break;
                }

                throw new Error('RelayClient internal exception. Gas price or gas limit still not calculated. Cannot happen.');

              case 14:
                if (!(gasPriceHex.indexOf('0x') !== 0)) {
                  _context9.next = 16;
                  break;
                }

                throw new Error("Invalid gasPrice hex string: ".concat(gasPriceHex));

              case 16:
                if (!(gasLimitHex.indexOf('0x') !== 0)) {
                  _context9.next = 18;
                  break;
                }

                throw new Error("Invalid gasLimit hex string: ".concat(gasLimitHex));

              case 18:
                gasLimit = parseInt(gasLimitHex, 16).toString();
                gasPrice = parseInt(gasPriceHex, 16).toString();
                value = (_a = gsnTransactionDetails.value) !== null && _a !== void 0 ? _a : '0';
                _context9.t0 = gsnTransactionDetails.to;
                _context9.t1 = gsnTransactionDetails.data;
                _context9.t2 = gsnTransactionDetails.from;
                _context9.t3 = value;
                _context9.t4 = senderNonce;
                _context9.t5 = gasLimit;
                _context9.next = 29;
                return validUntilPromise;

              case 29:
                _context9.t6 = _context9.sent;
                _context9.t7 = {
                  to: _context9.t0,
                  data: _context9.t1,
                  from: _context9.t2,
                  value: _context9.t3,
                  nonce: _context9.t4,
                  gas: _context9.t5,
                  validUntil: _context9.t6
                };
                _context9.t8 = {
                  pctRelayFee: relayInfo.relayInfo.pctRelayFee,
                  baseRelayFee: relayInfo.relayInfo.baseRelayFee,
                  gasPrice: gasPrice,
                  paymaster: paymaster,
                  paymasterData: '',
                  clientId: this.config.clientId,
                  forwarder: forwarder,
                  relayWorker: relayWorker
                };
                relayRequest = {
                  request: _context9.t7,
                  relayData: _context9.t8
                };
                _context9.next = 35;
                return this.dependencies.asyncPaymasterData(relayRequest);

              case 35:
                relayRequest.relayData.paymasterData = _context9.sent;
                this.emit(new GsnEvents_1.GsnSignRequestEvent());
                _context9.next = 39;
                return this.dependencies.accountManager.sign(relayRequest);

              case 39:
                signature = _context9.sent;
                _context9.next = 42;
                return this.dependencies.asyncApprovalData(relayRequest);

              case 42:
                approvalData = _context9.sent;
                _context9.next = 45;
                return this.dependencies.contractInteractor.getTransactionCount(relayWorker);

              case 45:
                transactionCount = _context9.sent;
                relayMaxNonce = transactionCount + this.config.maxRelayNonceGap; // TODO: the server accepts a flat object, and that is why this code looks like shit.
                //  Must teach server to accept correct types

                metadata = {
                  relayHubAddress: relayHubAddress,
                  signature: signature,
                  approvalData: approvalData,
                  relayMaxNonce: relayMaxNonce
                };
                httpRequest = {
                  relayRequest: relayRequest,
                  metadata: metadata
                };
                this.logger.info("Created HTTP relay request: ".concat(JSON.stringify(httpRequest)));
                return _context9.abrupt("return", httpRequest);

              case 51:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function _prepareRelayHttpRequest(_x6, _x7) {
        return _prepareRelayHttpRequest2.apply(this, arguments);
      }

      return _prepareRelayHttpRequest;
    }()
  }, {
    key: "newAccount",
    value: function newAccount() {
      this._verifyInitialized();

      return this.dependencies.accountManager.newAccount();
    }
  }, {
    key: "addAccount",
    value: function addAccount(privateKey) {
      this._verifyInitialized();

      this.dependencies.accountManager.addAccount(privateKey);
    }
  }, {
    key: "_verifyInitialized",
    value: function _verifyInitialized() {
      if (!this.initialized) {
        throw new Error('not initialized. must call RelayClient.init()');
      }
    }
  }, {
    key: "auditTransaction",
    value: function () {
      var _auditTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(hexTransaction, sourceRelayUrl) {
        var auditors, failedAuditorsCount, _iterator, _step, auditor, penalizeResponse;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                auditors = this.dependencies.knownRelaysManager.getAuditors([sourceRelayUrl]);
                failedAuditorsCount = 0;
                _iterator = _createForOfIteratorHelper(auditors);
                _context10.prev = 3;

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context10.next = 21;
                  break;
                }

                auditor = _step.value;
                _context10.prev = 7;
                _context10.next = 10;
                return this.dependencies.httpClient.auditTransaction(auditor, hexTransaction);

              case 10:
                penalizeResponse = _context10.sent;

                if (!(penalizeResponse.commitTxHash != null)) {
                  _context10.next = 13;
                  break;
                }

                return _context10.abrupt("return", penalizeResponse);

              case 13:
                _context10.next = 19;
                break;

              case 15:
                _context10.prev = 15;
                _context10.t0 = _context10["catch"](7);
                failedAuditorsCount++;
                this.logger.info("Audit call failed for relay at URL: ".concat(auditor, ". Failed audit calls: ").concat(failedAuditorsCount, "/").concat(auditors.length));

              case 19:
                _context10.next = 5;
                break;

              case 21:
                _context10.next = 26;
                break;

              case 23:
                _context10.prev = 23;
                _context10.t1 = _context10["catch"](3);

                _iterator.e(_context10.t1);

              case 26:
                _context10.prev = 26;

                _iterator.f();

                return _context10.finish(26);

              case 29:
                if (auditors.length === failedAuditorsCount && failedAuditorsCount !== 0) {
                  this.logger.error('All auditors failed!');
                }

                return _context10.abrupt("return", {
                  message: "Transaction was not audited. Failed audit calls: ".concat(failedAuditorsCount, "/").concat(auditors.length)
                });

              case 31:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[3, 23, 26, 29], [7, 15]]);
      }));

      function auditTransaction(_x8, _x9) {
        return _auditTransaction.apply(this, arguments);
      }

      return auditTransaction;
    }()
  }, {
    key: "getUnderlyingProvider",
    value: function getUnderlyingProvider() {
      return this.rawConstructorInput.provider;
    }
  }, {
    key: "_resolveConfiguration",
    value: function () {
      var _resolveConfiguration2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref2) {
        var provider, _ref2$config, config;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                provider = _ref2.provider, _ref2$config = _ref2.config, config = _ref2$config === void 0 ? {} : _ref2$config;
                return _context11.abrupt("return", Object.assign(Object.assign({}, GSNConfigurator_1.defaultGsnConfig), config));

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function _resolveConfiguration(_x10) {
        return _resolveConfiguration2.apply(this, arguments);
      }

      return _resolveConfiguration;
    }()
  }, {
    key: "_resolveDependencies",
    value: function () {
      var _resolveDependencies2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref3) {
        var provider, _ref3$config, config, _ref3$overrideDepende, overrideDependencies, _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, versionManager, contractInteractor, accountManager, httpClient, pingFilter, relayFilter, asyncApprovalData, asyncPaymasterData, scoreCalculator, knownRelaysManager, transactionValidator;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                provider = _ref3.provider, _ref3$config = _ref3.config, config = _ref3$config === void 0 ? {} : _ref3$config, _ref3$overrideDepende = _ref3.overrideDependencies, overrideDependencies = _ref3$overrideDepende === void 0 ? {} : _ref3$overrideDepende;
                versionManager = new VersionsManager_1.VersionsManager(Version_1.gsnRuntimeVersion, (_a = config.requiredVersionRange) !== null && _a !== void 0 ? _a : Version_1.gsnRequiredVersion);

                if (!((_b = overrideDependencies === null || overrideDependencies === void 0 ? void 0 : overrideDependencies.contractInteractor) !== null && _b !== void 0)) {
                  _context12.next = 6;
                  break;
                }

                _context12.t0 = _b;
                _context12.next = 9;
                break;

              case 6:
                _context12.next = 8;
                return new ContractInteractor_1.ContractInteractor({
                  provider: provider,
                  versionManager: versionManager,
                  logger: this.logger,
                  maxPageSize: this.config.pastEventsQueryMaxPageSize,
                  deployment: {
                    paymasterAddress: config === null || config === void 0 ? void 0 : config.paymasterAddress
                  }
                }).init();

              case 8:
                _context12.t0 = _context12.sent;

              case 9:
                contractInteractor = _context12.t0;
                accountManager = (_c = overrideDependencies === null || overrideDependencies === void 0 ? void 0 : overrideDependencies.accountManager) !== null && _c !== void 0 ? _c : new AccountManager_1.AccountManager(provider, contractInteractor.chainId, this.config);
                httpClient = (_d = overrideDependencies === null || overrideDependencies === void 0 ? void 0 : overrideDependencies.httpClient) !== null && _d !== void 0 ? _d : new HttpClient_1.HttpClient(new HttpWrapper_1.HttpWrapper(), this.logger);
                pingFilter = (_e = overrideDependencies === null || overrideDependencies === void 0 ? void 0 : overrideDependencies.pingFilter) !== null && _e !== void 0 ? _e : exports.GasPricePingFilter;
                relayFilter = (_f = overrideDependencies === null || overrideDependencies === void 0 ? void 0 : overrideDependencies.relayFilter) !== null && _f !== void 0 ? _f : KnownRelaysManager_1.EmptyFilter;
                asyncApprovalData = (_g = overrideDependencies === null || overrideDependencies === void 0 ? void 0 : overrideDependencies.asyncApprovalData) !== null && _g !== void 0 ? _g : exports.EmptyDataCallback;
                asyncPaymasterData = (_h = overrideDependencies === null || overrideDependencies === void 0 ? void 0 : overrideDependencies.asyncPaymasterData) !== null && _h !== void 0 ? _h : exports.EmptyDataCallback;
                scoreCalculator = (_j = overrideDependencies === null || overrideDependencies === void 0 ? void 0 : overrideDependencies.scoreCalculator) !== null && _j !== void 0 ? _j : KnownRelaysManager_1.DefaultRelayScore;
                knownRelaysManager = (_k = overrideDependencies === null || overrideDependencies === void 0 ? void 0 : overrideDependencies.knownRelaysManager) !== null && _k !== void 0 ? _k : new KnownRelaysManager_1.KnownRelaysManager(contractInteractor, this.logger, this.config, relayFilter);
                transactionValidator = (_l = overrideDependencies === null || overrideDependencies === void 0 ? void 0 : overrideDependencies.transactionValidator) !== null && _l !== void 0 ? _l : new RelayedTransactionValidator_1.RelayedTransactionValidator(contractInteractor, this.logger, this.config);
                return _context12.abrupt("return", {
                  logger: this.logger,
                  httpClient: httpClient,
                  contractInteractor: contractInteractor,
                  knownRelaysManager: knownRelaysManager,
                  accountManager: accountManager,
                  transactionValidator: transactionValidator,
                  pingFilter: pingFilter,
                  relayFilter: relayFilter,
                  asyncApprovalData: asyncApprovalData,
                  asyncPaymasterData: asyncPaymasterData,
                  scoreCalculator: scoreCalculator
                });

              case 20:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function _resolveDependencies(_x11) {
        return _resolveDependencies2.apply(this, arguments);
      }

      return _resolveDependencies;
    }()
  }]);

  return RelayClient;
}();

exports.RelayClient = RelayClient;

function _dumpRelayingResult(relayingResult) {
  var str = '';

  if (relayingResult.pingErrors.size > 0) {
    str += "Ping errors (".concat(relayingResult.pingErrors.size, "):");
    Array.from(relayingResult.pingErrors.keys()).forEach(function (e) {
      var _a, _b;

      var err = relayingResult.pingErrors.get(e);
      var error = (_b = (_a = err === null || err === void 0 ? void 0 : err.message) !== null && _a !== void 0 ? _a : err === null || err === void 0 ? void 0 : err.toString()) !== null && _b !== void 0 ? _b : '';
      str += "\n".concat(e, " => ").concat(error, "\n");
    });
  }

  if (relayingResult.relayingErrors.size > 0) {
    str += "Relaying errors (".concat(relayingResult.relayingErrors.size, "):\n");
    Array.from(relayingResult.relayingErrors.keys()).forEach(function (e) {
      var _a, _b;

      var err = relayingResult.relayingErrors.get(e);
      var error = (_b = (_a = err === null || err === void 0 ? void 0 : err.message) !== null && _a !== void 0 ? _a : err === null || err === void 0 ? void 0 : err.toString()) !== null && _b !== void 0 ? _b : '';
      str += "".concat(e, " => ").concat(error);
    });
  }

  return str;
}

exports._dumpRelayingResult = _dumpRelayingResult;